import script from "./meetingRegist.vue?vue&type=script&lang=ts&setup=true"
export * from "./meetingRegist.vue?vue&type=script&lang=ts&setup=true"

import "./meetingRegist.vue?vue&type=style&index=0&id=3fdf8e4d&lang=less&scoped=true"

import exportComponent from "/Users/houxingzhe/Documents/parttime/P 1/2023国家智能车发展论坛/new2/nivdf2023/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fdf8e4d"]])

export default __exports__